import { render, staticRenderFns } from "./GashaponRecord.vue?vue&type=template&id=6ed1766c&scoped=true"
import script from "./GashaponRecord.vue?vue&type=script&lang=js"
export * from "./GashaponRecord.vue?vue&type=script&lang=js"
import style0 from "./GashaponRecord.vue?vue&type=style&index=0&id=6ed1766c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed1766c",
  null
  
)

export default component.exports